var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 203,
    viewBox: "0 0 283 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.1446 27.3457H36.8542C34.5748 27.3457 32.4036 28.318 30.8858 30.0185L14.3031 48.5972C12.9947 50.0631 12.2715 51.9594 12.2715 53.9243V123.6V192.346H207.392H233.688C235.968 192.346 238.139 191.373 239.657 189.672L256.241 171.085C257.549 169.619 258.271 167.723 258.271 165.759V96.091V27.3457H63.1446Z",
    fill: "#72E558",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.271 128.346V165.181C267.271 170.131 265.523 174.922 262.335 178.708L249.565 193.873C245.575 198.611 239.696 201.346 233.502 201.346H205.271",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27148 74.3457L2.27148 54.1249C2.27148 49.238 3.97586 44.504 7.09099 40.7387L20.9726 23.9594C24.962 19.1372 30.8945 16.3457 37.1531 16.3457L74.2715 16.3457",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.738 23.1002C239.739 23.1002 233.738 23.1002 229.738 23.1002L226.822 2.69149C232.321 2.69149 235.322 2.69068 241.322 2.69144L243.738 23.1002ZM262.032 34.8906C262.032 24.1914 257.322 23.1002 247.822 23.1002L245.822 2.69146C265.321 2.01084 280.738 4.89074 279.739 38.8901L262.032 34.8906ZM262.032 52.3908C262.222 48.6122 262.034 43.3905 262.032 39.8905L279.739 43.8905C279.739 49.8131 279.739 51.8908 279.739 57.3908L262.032 52.3908Z",
    fill: "url(#paint0_linear_18_24)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.426 23.1002C221.426 23.1002 214.306 23.1002 210.306 23.1002L206.822 2.69137C212.321 2.69137 216.322 2.6906 222.322 2.69137L225.426 23.1002Z",
    fill: "url(#paint1_linear_18_24)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_24",
    x1: 250.991,
    y1: 1.42703,
    x2: 282.822,
    y2: 75.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72E558",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F9E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_24",
    x1: 250.991,
    y1: 1.42703,
    x2: 282.822,
    y2: 75.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72E558",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F9E16"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRating);
export default __webpack_public_path__ + "static/media/low-rating.2dda9445b3e3cf8e1aa067e0c4b6be24.svg";
export { ForwardRef as ReactComponent };